import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCapacityPeopleEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-capacity-people-embed',
	exact: true,
	path: '/jira/core/projects/:projectKey/capacity/people/embed',
};
